import { render, staticRenderFns } from "./VinylePochette.vue?vue&type=template&id=0c4c3051&scoped=true&"
import script from "./VinylePochette.vue?vue&type=script&lang=ts&"
export * from "./VinylePochette.vue?vue&type=script&lang=ts&"
import style0 from "./VinylePochette.vue?vue&type=style&index=0&id=0c4c3051&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c4c3051",
  null
  
)

export default component.exports